import _, { now } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { Pagination, Dimmer, Loader, Segment, Header, Icon, Table, Button, Grid, Confirm, Modal } from 'semantic-ui-react'
import './SellerDriverListContainer.less';
import '../../assets/css/chkbox-style.css'
import '../../components/FormControls/Checkbox/DGCheckbox.less'
import { getSellerCustomerRequestsList, updateSellerNotes, sendFormEntrySMSToCustomer, deleteSCRequest, updateSCRequestBookingDate, resetBookedSCRequest } from '../../services/Seller'
import { getSellerDrivers, resendInviteLink } from '../../services/Driver'
import SellerNotesModal from '../../components/SellerCustomer/SellerNotesModal/SellerNotesModal';
import RequestInvoiceDetailModal from '../../components/SellerCustomer/RequestInvoiceDetailModal/RequestInvoiceDetailModal';
import RequestDetailCard from '../../components/SellerCustomer/RequestDetailCard/RequestDetailCard';
import { format } from 'react-phone-input-auto-format'
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Calendar from '../../assets/images/newui/Calendar.svg'
import deleteImg from '../../assets/images/newui/remove-img.svg'
import { NavigationUrls } from '../../constants/NavigationUrls';

function SellerDriverContainer(props) {
    const [loading, setLoading] = useState(false);
    const [sellerDrivers, setSellerDrivers] = useState([]);
    const [paginationState, setPaginationState] = useState({
        rowsPerPage: 10,
        activePage: 1,
        recordCount: 0,
    })
    const [sellerNotesModalOpen, setSellerNotesModalOpen] = useState(false)
    const [selectedRequest, setSelectedRequest] = useState({});
    const [requestInvoiceDetailModalOpen, setRequestInvoiceDetailModalOpen] = useState(false)
    const [notificationState, setNotificationState] = useState({
        isShow: false,
        type: "",
        message: ""
    });
    const [sendingSms, setSendingSms] = useState(false);
    const [showSendLinkButton, setShowSendLinkButton] = useState(false);

    const [disableAddCustomerRequestButton, setDisableAddCustomerRequestButton] = useState(false)
    const currentUser = useSelector(({ auth }) => auth.currentUser);

    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [showBookModal, setShowBookModal] = useState(false);

    const [bookDate, setBookDate] = useState(null);
    const [selectedServiceID, setSelectedServiceID] = useState(0);
    const [selectedRequestID, setSelectedRequestID] = useState(0);
    const [isBooked, setIsBooked] = useState(false);


    //    const onChange = (timeValue) => {
    //       setValue(timeValue);
    //    }
    let notficationTimeOut = undefined;

    useEffect(() => {
        loadData();
    }, [paginationState.activePage])

    const loadData = async () => {
        setLoading(true);
        let option = paginationState;
        console.log("option", option)
        let res = await getSellerDrivers(option);
        let res2 = await getSellerCustomerRequestsList(option);
        if (res.resStatus == 200) {
            setSellerDrivers(res.data.sellerDrivers)
            setPaginationState({ ...paginationState, recordCount: res.data.count })
        }
        setLoading(false);
    }

    const onPageChange = (e, d) => {
        setPaginationState({ ...paginationState, activePage: d.activePage })
    }

    const onSellerNotesIconClick = (selectedRequest) => {
        setSelectedRequest(selectedRequest);
        setSellerNotesModalOpen(true)
    }

    const handleSellerNotesModalClose = () => {
        setSellerNotesModalOpen(false);
    }

    const onSellerNotesSubmit = async (value) => {
        let res = await updateSellerNotes(selectedRequest.scRequestID, value);
        if (res.resStatus == 200) {
            setSellerNotesModalOpen(false);
            loadData();
        }
    }

    const onRequestUpdateButtonClick = (requestToken) => {
        props.history.push(`/customer/request/form/${requestToken}`)
    }

    const onRequestInvoiceDetailButtonClick = (selectedRequest) => {
        setSelectedRequest(selectedRequest);
        setRequestInvoiceDetailModalOpen(true)
    }

    const handleInvoiceDetailModalClose = () => {
        setRequestInvoiceDetailModalOpen(false);
    }
    const handleCustomerFormEntryLinkSMS = async (scRequestID) => {
        setSendingSms(true);
        let res = await sendFormEntrySMSToCustomer(scRequestID);
        if (res.resStatus == 200) {
            setNotificationState({
                isShow: true,
                type: "success",
                message: "Form entry link sms sent successfully to customer."
            })
        } else {
            setNotificationState({
                isShow: true,
                type: "error",
                message: res.message
            })
        }
        setSendingSms(false);
        if (notficationTimeOut) {
            clearTimeout(notficationTimeOut)
        }
        notficationTimeOut = setTimeout(() => {
            setNotificationState({
                isShow: false,
                type: "",
                message: ""
            })
        }, 3500);
    }

    const handleResendInviteLinkToDriver = async (sellerDriverID) => {
        let res = await resendInviteLink(sellerDriverID);
  
        if (res.resStatus == 200) {
            setNotificationState({
                isShow: true,
                type: "success",
                message: "Invite link sent successfully to driver."
            })
        } else {
            setNotificationState({
                isShow: true,
                type: "error",
                message: res.message
            })
        }

        if (notficationTimeOut) {
            clearTimeout(notficationTimeOut)
        }
        notficationTimeOut = setTimeout(() => {
            setNotificationState({
                isShow: false,
                type: "",
                message: ""
            })
        }, 3500);
    }

    const handleAddSellerDriverButtonClick = () => {
        props.history.push(NavigationUrls.INVITE_SELLER_DRIVER)
    }

    return (
        <>
            <div className={"seller-driver-container"}>
                {loading ? <Dimmer active>
                    <Loader indeterminate size='massive' />
                </Dimmer> : ''}
                <Segment.Group>
                    <Segment size="massive" className="no-radius">
                        <Header as="h1">
                            <Header.Content>
                                <Icon name='list' size='small' />
                                Drivers
                                {
                                    window.innerWidth >= 768 && currentUser && currentUser.Seller ?
                                        <Button onClick={disableAddCustomerRequestButton ? () => { } : () => { handleAddSellerDriverButtonClick() }}
                                            className={"add-item-button"}>
                                            + Add
                                        </Button>
                                        :
                                        ""
                                }
                            </Header.Content>
                        </Header>
                    </Segment>
                </Segment.Group>
                {
                    (sellerDrivers && sellerDrivers.length > 0) ?
                        <>
                            {
                                notificationState.isShow ?
                                    <GeneralMessage type={notificationState.type} message={notificationState.message} /> : ""
                            }

                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Name</Table.HeaderCell>
                                        <Table.HeaderCell>Email</Table.HeaderCell>
                                        <Table.HeaderCell>Phone</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Invite Link</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        sellerDrivers.sort((a, b) => moment(b.updatedAt) - moment(a.updatedAt)).map((sellerDriver, sellerDriverIndex) => {
                                            return <>
                                                <Table.Row>
                                                    {/*<Table.Cell>{request.scRequestID}</Table.Cell>  */}
                                                    <Table.Cell>{sellerDriver.firstName + " " + sellerDriver.lastName}</Table.Cell>
                                                    <Table.Cell>{sellerDriver.email}</Table.Cell>
                                                    <Table.Cell>{sellerDriver.cellPhone}</Table.Cell>
                                                    <Table.Cell>{sellerDriver.status ? sellerDriver?.status?.toUpperCase() : "-"}</Table.Cell>
                                                    {  
                                                        <Table.Cell>{
                                                            sellerDriver?.status?.toUpperCase() == "PENDING" ?
                                                            <>
                                                                <Button onClick={() => { handleResendInviteLinkToDriver(sellerDriver.sellerDriverID)}}
                                                                    className={"resent-button"} >
                                                                Send
                                                                </Button>
                                                            </>
                                                         : "-"
                                                        }</Table.Cell>
                                                    }
                                                </Table.Row>
                                            </>
                                        })
                                    }
                                </Table.Body>
                            </Table>
                            <Pagination className={"pagination-container"} activePage={paginationState.activePage}
                                totalPages={paginationState.recordCount && paginationState.recordCount / paginationState.rowsPerPage || 1}
                                disabled={loading}
                                onPageChange={(e, d) => onPageChange(e, d)}
                            />
                        </>
                        :
                        <>
                            <div className={"no-seller-driver-heading-container"}>
                                <h1>
                                    No Seller Driver
                                </h1>
                            </div>
                        </>
                }
                {
                    window.innerWidth < 768 && currentUser && currentUser.Seller ?
                        <div onClick={disableAddCustomerRequestButton ? () => { } : () => { handleAddSellerDriverButtonClick() }}
                            className={`add-driver-float-button-container ${disableAddCustomerRequestButton ? " disabled" : ""}`}>
                            <p>
                                +
                            </p>
                        </div> : ""
                }
            </div>
        </>
    )
}

export default withRouter(SellerDriverContainer)
